import React, { useState } from "react";
import FAQImage from "./Assets/FaqImage.png";
import { FaPlus, FaMinus } from 'react-icons/fa';
import Ribbon from "./Assets/ribbon.png";
import faqData from '../../../JsonFiles/LandingPageFAQ.json'; // Adjust the path as needed


// const faqData = [
//     {
//       category: "General",
//       items: [
//         {
//           question: "What is Vehicle Learning Innovation (VLI)?",
//           answer: "VLI is a centralized digital Marketplace that connects learners with verified,  MTO-approved driving institutes and/or renowned machine operator training centers across Ontario, Canada...",
//         },
//         {
//           question: "Who can use VLI?",
//           answer: "Our platform is designed for both learners and  MTO approved training institutes...",
//         },
//       ],
//     },
//     {
//       category: "Learner",
//       items: [
//         {
//           question: "How do I enroll in a course through VLI?",
//           answer: "Simply visit our platform, compare approved institutes...",
//         },
//         {
//           question: "Are all institutes on VLI approved by the Ministry of Transportation ( MTO)?",
//           answer: "Yes. We only partner with  MTO-approved driving institutes...",
//         },
//         {
//           question: "Can I monitor my progress online?",
//           answer: "Absolutely! Our personalized learner dashboard lets you track your progress...",
//         },
//         {
//           question: "What if I need help or have a complaint about an institute?",
//           answer: "You can contact our support team anytime...",
//         },
//       ],
//     },
//     {
//       category: "Institute",
//       items: [
//         {
//           question: "How can my institute partner with VLI?",
//           answer: "You can sign up directly on our website...",
//         },
//         {
//           question: "What are the benefits of joining VLI as a partner?",
//           answer: "Partnering with VLI boosts your institute’s visibility...",
//         },
//         {
//           question: "Does VLI offer marketing or promotional support?",
//           answer: "Yes! We help our partner institutes stand out...",
//         },
//       ],
//     },
//     {
//       category: "Security",
//       items: [
//         {
//           question: "Is my personal information safe on VLI?",
//           answer: "Absolutely. We use secure encryption and data protection protocols...",
//         },
//         {
//           question: "What support is available if I face any issues?",
//           answer: "Our dedicated support team is available via email...",
//         },
//       ],
//     },
//   ];

const FrequentlyAskedQuestions = () => {
    const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="w-full  mt-[20px] lg:mt-[40px] flex flex-col gap-[20px] mb-[50px]">
        <p className="italic text-[28px] lg:text-[38px] font-semibold text-center">Frequently Asked Questions</p>

        <div className="w-full flex flex-col justify-center items-center lg:mt-[20px]">
            <img src={FAQImage} alt="FAQImage" className="w-[70%]"  />

            <div className="w-[90%] lg:w-[70%] mt-[20px] flex flex-col gap-[40px]">
                {/* <div
                className={`relative pl-[70px] py-[15px] pr-[20px] rounded-[20px] transition-all ${
                    isOpen ? ' bg-white pb-[30px]' : ''
                }`}
                style={!isOpen ? { background: 'linear-gradient(90deg, #372354 0%, #572E8F 100%)' } : {border: "3px solid #4B2A79"}}
                >
                    <div className="absolute top-[-17px] left-[-19px]">
                        <div className="relative">
                            <p className="absolute top-[30px] left-[7px] rotate-[-43deg] text-[18px] font-semibold tracking-widest text-white">
                                Security
                            </p>
                        </div>
                        <img className="w-[150px]" src={Ribbon} alt="" />
                    </div>

                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <h3
                        className={`text-[25px] italic font-semibold ${
                            isOpen ? 'text-[#62269C]' : 'text-white'
                        }`}
                        >
                            Is My Personal Information Safe On VLI?
                        </h3>
                        <div className="w-[50px] h-[50px] flex justify-center items-center rounded-full bg-[#A1A3EF]">
                            {isOpen ? <FaMinus className="text-white"/> : <FaPlus className="text-white" />}
                        </div>
                    </div>

                    {isOpen && (
                        <div className="mt-[10px] text-[22px] text-[#382355] ">
                        Absolutely. We use secure encryption and data protection protocols to ensure that all student and institute data is kept private and protected.
                        </div>
                    )}
                </div> */}

                {faqData.map((section, sectionIndex) =>
                    section.items.map((faq, faqIndex) => {
                        const index = `${sectionIndex}-${faqIndex}`;
                        const isOpen = openIndex === index;

                        return (
                        <div
                            key={index}
                            className={`relative pl-[50px] lg:pl-[70px] py-[15px] pr-[20px] rounded-[20px] transition-all ${
                            isOpen ? 'bg-white pb-[30px]' : ''
                            }`}
                            style={
                            isOpen
                                ? { border: '3px solid #4B2A79' }
                                : { background: 'linear-gradient(90deg, #372354 0%, #572E8F 100%)' }
                            }
                        >
                            {/* Ribbon */}
                            <div className="absolute top-[-5px] lg:top-[-14px] left-[-5px] lg:left-[-19px]">
                                <div className="relative">
                                    <p className="absolute top-[13px] lg:top-[30px] left-[4px] lg:left-[7px] rotate-[-43deg] text-[12px] lg:text-[18px] font-semibold tracking-widest text-white">
                                    {section.category}
                                    </p>
                                </div>
                                <img className="w-[150px] hidden lg:block" src={Ribbon} alt="TopRibbon"/>
                                <img className="lg:hidden" src={require("./Assets/RibbonPink.svg").default} alt="TopMobileRibbon"  />

                            </div>

                            {/* Question Row */}
                            <div
                            className="flex flex-col lg:flex-row lg:justify-between lg:items-center cursor-pointer"
                            onClick={() =>
                                setOpenIndex((prev) => (prev === index ? null : index))
                            }
                            >
                            <h3
                                className={`text-[18px] lg:text-[25px] italic font-semibold ${
                                isOpen ? 'text-[#62269C]' : 'text-white'
                                }`}
                            >
                                {faq.question}
                            </h3>
                                <div className="w-[30px] lg:w-[50px] h-[30px] lg:h-[50px] hidden lg:flex justify-center items-center rounded-full bg-[#A1A3EF]">
                                    {isOpen ? <FaMinus className="text-white" /> : <FaPlus className="text-white" />}
                                </div>
                            <div className="w-full lg:hidden flex justify-end">
                                <div className="w-[30px] lg:w-[50px] h-[30px] lg:h-[50px] lg:hidden flex justify-center items-center rounded-full bg-[#A1A3EF]">
                                    {isOpen ? <FaMinus className="text-white" /> : <FaPlus className="text-white" />}
                                </div>
                            </div>
                            </div>

                            {/* Answer Section */}
                            {isOpen && (
                            <div className="mt-[10px] text-[16px] lg:text-[22px] text-[#382355]">
                                {faq.answer}
                            </div>
                            )}
                        </div>
                        );
                    })
                )}
            </div>
        </div>

        
    </div>
  );
};

export default FrequentlyAskedQuestions;
